/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_NotesInputs */

const cs_parties_notes = /** @type {(inputs: Parties_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámky`)
};

const en_parties_notes = /** @type {(inputs: Parties_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Parties_NotesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_notes = /** @type {((inputs?: Parties_NotesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_NotesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_notes(inputs)
	return cs_parties_notes(inputs)
});